/**
 * "10:24" para hoje, "Ontem", "Seg", e a data para o que é mais velho que a semana.
 *
 * Morava na `HomePage` e a lista de conversas do assistente importava de lá; saiu
 * para cá em 07/10/2026, quando a Home deixou de mostrar as conversas recentes.
 */
export const quando = (iso: string) => {
    const data = new Date(iso);
    const agora = new Date();
    const dia = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const diasAtras = Math.round((dia(agora) - dia(data)) / 86400000);

    if (diasAtras <= 0) return data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    if (diasAtras === 1) return 'Ontem';
    if (diasAtras < 7) return data.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '');
    return data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
};
